import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DynamicLayoutSlotComponent } from '@frontend/vanilla/core';
import { BootstrapQuickLink } from 'packages/sports/web/app/src/quick-links/quick-links.bootstrap';

import CountQuickLinksComponent from './components/count-quick-links.component';
import QuickLinksComponent from './components/quick-links.component';

@NgModule({
    imports: [CommonModule, DynamicLayoutSlotComponent],
    declarations: [CountQuickLinksComponent, QuickLinksComponent],
    providers: [BootstrapQuickLink],
    exports: [CountQuickLinksComponent, QuickLinksComponent],
})
export default class BetslipDigitalQuickLinksModule {
    constructor(quickLinksBootstrap: BootstrapQuickLink) {
        quickLinksBootstrap.registerCountQuickLinks();
        quickLinksBootstrap.registerQuickLinks();
    }
}
